
import React from 'react';
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { TrashIcon, ExternalLink } from 'lucide-react';
import { AuthorizedUser } from '@/types/authorizedUser';

interface UsersTableProps {
  users: AuthorizedUser[];
  onDeleteUser: (userId: string) => Promise<void>;
}

const UsersTable: React.FC<UsersTableProps> = ({ users, onDeleteUser }) => {
  return (
    <div className="rounded-md border overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Account Number</TableHead>
            <TableHead>License Number</TableHead>
            <TableHead className="w-[80px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.id}>
              <TableCell className="font-medium">
                <a 
                  href={`/user-portal/${user.id}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center text-primary hover:underline"
                >
                  {user.name}
                  <ExternalLink className="ml-1 h-3 w-3" />
                </a>
              </TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>{user.accountNumber}</TableCell>
              <TableCell>{user.licenseNumber}</TableCell>
              <TableCell>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onDeleteUser(user.id)}
                  className="text-destructive hover:text-destructive"
                >
                  <TrashIcon className="h-4 w-4" />
                  <span className="sr-only">Delete</span>
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default UsersTable;
